import * as dataActions from '@/data/data-actions';
import { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { LicenseStatusInfoText } from '../license-modules/license-status-info-text';
import { LicenseStatusDropdown } from '../license-status-dropdown';

export function RenewalStatusSwitcher(props) {
  const { index, renewalDict, showDropdown } = props;

  const dispatch = useDispatch();

  const userUpdatedLicenseRenewalStatus = useCallback(
    (renewalStatus) => {
      dispatch(
        dataActions.userUpdatedLicenseRenewalStatus({
          renewalId: renewalDict.id,
          renewalStatus,
          oldStatus: renewalDict.status,
          index,
        })
      );
    },
    [dispatch, renewalDict, index]
  );

  if (!showDropdown) return null;

  return (
    <div>
      <LicenseStatusInfoText renewalInfo={renewalDict} show={showDropdown} />

      <LicenseStatusDropdown
        ariaLabel="Dropdown menu of renewal statuses"
        loading={Boolean(renewalDict.inFlight)}
        options={renewalDict.availableStatusChanges}
        selected={renewalDict.status}
        setSelected={userUpdatedLicenseRenewalStatus}
      />
    </div>
  );
}
